import React, {FC, useState} from 'react'
import {useEffectOnce} from 'react-use'
import {RouteComponentProps} from 'react-router-dom'
import classnames from 'classnames'
import {Row, Col} from 'antd'
import '@/styles/page/WeixinPay.less'

import QRCode from 'qrcode.react'

/*
routerComponentPros match.params
价格： price
二维码地址：erweima
订单号： orderCode
*/
type WeixinPayProps = RouteComponentProps
const WeixinPay: FC<WeixinPayProps> = props => {
  console.log(props.match.params)
  const {price, erweima, orderCode} = props.match.params as any
  const [showTime, setShowTime] = useState('30分00秒')

  useEffectOnce(() => {
    let time = 30 * 60
    let timer = setInterval(() => {
      let min = Math.floor(time / 60)
      let second = Math.floor(time % 60)
      setShowTime(`${min}分钟${second}秒`)

      time--;
      if(time < 0){
        clearInterval(timer)
      }
    }, 1000)
  })


  return (
    <div className={classnames('gc_WeixinPay')}>
      <Row className={classnames('gc_erweima')}>
        <Col className={classnames('gc_price')}><span>¥</span>{price}</Col>
        <Col className={classnames('gc_erweimaImg')}>
          <QRCode
            value={decodeURIComponent(erweima)}
            size={180}
          ></QRCode>
        </Col>
        <Col className={classnames('gc_erweima_desc')}>请使用微信扫描二维码</Col>
      </Row>
      <Row gutter={[0, 10]}>
        <Col>
          <Row type={'flex'}>
            <Col span={4} offset={9}>订单号</Col>
            <Col span={4} className={classnames('gc_fontRight')}>{orderCode}</Col>
          </Row>
        </Col>
        <Col>
          <Row type={'flex'} >
            <Col span={4} offset={9}>订单关闭时间</Col>
            <Col span={4} className={classnames('gc_fontRight')}>{showTime}</Col>
          </Row>
        </Col>
      </Row>
      <div className={classnames('gc_weixin_pay_bootom')}>
        如果支付遇到问题，请联系客服电话：400-000-000
      </div>
    </div>
  )
}

export default WeixinPay
